module.exports = __webpack_public_path__ + "img/error-yeti.2fbf9078.png";